import { RESERVATION_COLUMNS } from '../Reservations/constants';
import {
  actionFormatter,
  dateFormatter,
  reservationCodeFormatter,
} from './formatters';

const {
  unitType,
  reservationCode,
  moveInDate,
  reservationCreated,
  actions,
} = RESERVATION_COLUMNS;

interface IColumn {
  label: string;
  key: string;
  formatter?: (value: any) => any;
  width?: any;
}

export const ReservationTableColumns: IColumn[] = [
  {
    label: unitType,
    key: 'unitTypeId',
    width: '20%',
  },
  {
    label: reservationCode,
    key: 'reservationCode',
    formatter: reservationCodeFormatter,
    width: '15%',
  },
  {
    label: moveInDate,
    key: 'moveInDate',
    formatter: dateFormatter,
    width: '20%',
  },
  {
    label: reservationCreated,
    key: 'reservationDate',
    formatter: dateFormatter,
    width: '20%',
  },
  {
    label: actions,
    key: 'moveInButton',
    formatter: actionFormatter,
    width: '25%',
  },
];
